import React, { useState, useEffect } from 'react';
import { QuickReply } from '../../../../types';
import { Button } from '../../../../components/ui/Button';
import Input from '../../../../components/ui/Input';
import Textarea from '../../../../components/ui/Textarea';
import Modal from '../../../../components/ui/Modal';

interface QuickReplyFormModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: Omit<QuickReply, 'id'>) => Promise<void>;
    replyToEdit?: QuickReply;
}

const QuickReplyFormModal: React.FC<QuickReplyFormModalProps> = ({ isOpen, onClose, onSave, replyToEdit }) => {
    const [shortcut, setShortcut] = useState('');
    const [message, setMessage] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            if (replyToEdit) {
                setShortcut(replyToEdit.shortcut);
                setMessage(replyToEdit.message);
            } else {
                setShortcut('');
                setMessage('');
            }
        }
    }, [isOpen, replyToEdit]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const formattedShortcut = shortcut.startsWith('/') ? shortcut : `/${shortcut}`;
        setIsSaving(true);
        try {
            await onSave({ shortcut: formattedShortcut, message });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <Modal.Header onClose={onClose}>
                {replyToEdit ? 'Editar Resposta Rápida' : 'Nova Resposta Rápida'}
            </Modal.Header>
            <Modal.Body>
                <form id="reply-form" onSubmit={handleSubmit} className="space-y-4">
                    <Input
                        label="Atalho"
                        name="shortcut"
                        type="text"
                        required
                        value={shortcut}
                        onChange={(e) => setShortcut(e.target.value)}
                        placeholder="/exemplo"
                        helperText="Digite o atalho que disparará a mensagem (ex: /saudacao)"
                        autoFocus
                    />
                    <Textarea
                        label="Mensagem"
                        name="message"
                        required
                        minRows={4}
                        className="resize-none"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Digite a mensagem completa..."
                    />
                </form>
            </Modal.Body>
            <Modal.Footer className="flex-col-reverse gap-2 sm:flex-row">
                <Button variant="secondary" onClick={onClose} className="w-full sm:w-auto" disabled={isSaving}>
                    Cancelar
                </Button>
                <Button type="submit" form="reply-form" className="w-full sm:w-auto" disabled={isSaving}>
                    {isSaving ? 'Salvando...' : 'Salvar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QuickReplyFormModal;
